import { render, staticRenderFns } from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=template&id=fe094342&scoped=true"
import script from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe094342",
  null
  
)

export default component.exports